/** TODO: find a better way to dispose sound without trashing Audiocontext */

import * as THREE from 'three';
import soundPath from '../../assets/sounds/francoise_rosen_-_blue_pentagon.wav';

export default class SoundController
{
    constructor(camera)
    {
        this.listener = new THREE.AudioListener();
        this.camera = camera;

        this.setup();
    }

    setup()
    {
        this.camera.add(this.listener);
        // console.log(this.listener);
    };

    playSound()
    {
        let sound = new THREE.Audio(this.listener);
        // load a sound and set it as the Audio object's buffer
        let audioLoader = new THREE.AudioLoader();  
        audioLoader.load(soundPath, (buffer) =>
        {
            sound.setBuffer(buffer);
            sound.setLoop(true);
            sound.setVolume(0.5);
            sound.play();
        })    
    };

    addPositionalSound(mesh)
    {
        let sound = new THREE.PositionalAudio(this.listener);
        // load a sound and set it as the Audio object's buffer
        let audioLoader = new THREE.AudioLoader();  
        audioLoader.load(soundPath, (buffer) =>
        {
            sound.setBuffer(buffer);
            sound.setRefDistance(20);
            sound.setLoop(true);
            sound.play();
        });
        mesh.add(sound);   
        this.sound = sound; 
    };

    dispose()
    {
        // this.listener.context.close();
        this.sound.stop();
    }
};